module.exports = __webpack_public_path__ + "static/media/card-product3.1cd31fc0.jpg";